import { Base } from '@studiometa/js-toolkit';

/**
 * Review
 *
 * Carte d'avis alimentée par les données lues sur le widget Judge.me.
 */
export default class Review extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Review',
    refs: ['score', 'date', 'title', 'content', 'author', 'product', 'star[]'],
  };

  /**
   * Fill the card with a review and reveal it.
   * @param {{ rating: number, title: string, content: string, author: string, product: string, date: string }} review
   */
  setData({ rating, title, content, author, product, date }) {
    this.$refs.score.textContent = `${rating}/5`;
    this.$refs.date.textContent = date;
    this.$refs.title.textContent = title;
    this.$refs.content.textContent = content;
    this.$refs.author.textContent = author;
    this.$refs.product.textContent = product;

    this.$refs.star.forEach((star, index) => {
      star.classList.toggle('text-star', index < rating);
    });

    this.$el.classList.remove('opacity-0');
  }
}
